import React, {useContext} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {setContractsValues, showSignaturePad} from "../../../actions/contractsActions";
import {getAlreadyFilledSignatureField, getFieldValue} from "./contractsFieldsFunctions";
import ContractsContext from "./contractsContext";

const ContractsPopupSignatureField = (props) => {

  const {fieldIndex, fieldName, fieldCoords, showSignaturePad, contractsValues, isRequired, coord, contractsList,
    setContractsValues} = props;

  const {activeContract, activeContractPage} = useContext(ContractsContext);

  const fieldValue = getFieldValue(activeContractPage, fieldIndex, activeContract, contractsValues);
  const style = {
    left: fieldCoords.left + fieldCoords.width / 2 - 20,
    top: fieldCoords.top + fieldCoords.height / 2 - 20
  }

  const onClick = () => {
    const signatureName = coord.fieldName;
    if (!fieldValue && signatureName) {
      const alreadySignedSameFieldValue = getAlreadyFilledSignatureField(signatureName, contractsValues, contractsList);
      if (alreadySignedSameFieldValue) {
        setContractsValues({
          contractId: activeContract.id,
          pageIndex: activeContractPage,
          fieldIndex,
          name: fieldName,
          value: alreadySignedSameFieldValue,
        });
        return
      }
    }
    showSignaturePad(true, {pageIndex: activeContractPage, fieldIndex, fieldName, signatureName })
  }

  if (fieldValue) {
    style.backgroundImage = "url(" + fieldValue + ")";
    return (
      <div className="contract-body-indicator contract-body-indicator-signed-image"
           style={style}
           onClick={onClick}>
      </div>
    )
  }

  return (
    <div className={"contract-body-indicator contract-body-indicator-signature"
      + (isRequired ? ' contract-body__custom-field-required' : "")}
         style={style}
         data-coordname={coord.fieldName}
         onClick={onClick}>
      <FormattedMessage id="contractSign.signHere"/>
    </div>
  )
};

ContractsPopupSignatureField.propTypes = {
  fieldIndex: PropTypes.number.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldCoords: PropTypes.object.isRequired,
  isRequired: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {contractsValues, contractsList} = store.contractSigningState;
  return {
    contractsValues,
    contractsList,
  };
};

const mapDispatchToProps = {
  showSignaturePad,
  setContractsValues,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractsPopupSignatureField)
